import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';
import { CloseIcon } from 'sharedComponents/Icons';
import { getFilterLabels as getGroupPageFilterLabels } from './filterUtils';
import { GroupClientsFiltersPropTypes } from '../../utils';

const FilterChips = ({ classes, filters, setFilters, getFilterLabels }) => {
  const labels = React.useMemo(() => getFilterLabels(filters), [filters]);
  const onDeleteChipHandler = (label) => {
    if (label.clear) {
      label.clear(filters, setFilters);
    }
  };

  return (
    <div className={classes.container}>
      {labels.map((label) => (
        <Chip
          key={label.label}
          data-testid="chip"
          label={label.label}
          deleteIcon={<CloseIcon onClick={() => onDeleteChipHandler(label)} />}
          classes={{ deleteIcon: classes.deleteIcon, root: classes.chipRoot }}
          onDelete={() => onDeleteChipHandler(label)}
          className={classes.chip}
        />
      ))}
      <div className={classes.placeholder} />
    </div>
  );
};

FilterChips.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  filters: GroupClientsFiltersPropTypes,
  setFilters: PropTypes.func,
  getFilterLabels: PropTypes.func,
};

FilterChips.defaultProps = {
  classes: {},
  filters: {},
  getFilterLabels: getGroupPageFilterLabels,
};

export default FilterChips;
